import { jsx as _jsx } from "react/jsx-runtime";
const BOX = {
    display: "inline-block",
    // knowledge-page design-spec §4.4: a 24px marker box, `margin: 0 -5px 0 -3px; padding: 0 2px`.
    minWidth: "var(--space-3)",
    height: "var(--space-3)",
    lineHeight: "var(--space-3)",
    margin: "0 -5px 0 -3px",
    padding: "0 var(--space-025)",
    borderRadius: "var(--radius-focus)",
    textAlign: "center",
    verticalAlign: "3px",
    // knowledge-page design-spec §3.3: 12px marker size.
    fontSize: "12px",
    fontFamily: "var(--font-sans)",
    fontVariantNumeric: "tabular-nums",
};
export function CitationMarker({ n, href, label }) {
    if (href === null) {
        return (_jsx("span", { "data-citation": "off", title: "Recording deleted", style: { ...BOX, color: "var(--ink-2)", fontWeight: "var(--type-body-weight-strong)" }, children: `[${n}]` }));
    }
    return (_jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", "data-citation": "", "aria-label": label, title: label, style: {
            ...BOX,
            color: "var(--accent)",
            fontWeight: "var(--type-body-weight-current)",
            textDecoration: "none",
            background: "var(--citation-bg, transparent)",
            transitionProperty: "background-color",
            transitionDuration: "var(--dur-fast)",
            transitionTimingFunction: "var(--ease-out)",
        }, children: `[${n}]` }));
}
